import * as Accordion from '@radix-ui/react-accordion';
import styled, { css } from 'styled-components';

import { CSSANIMATIONS } from 'shared/presentation/constants';

export const Item = styled(Accordion.Item)`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    border-radius: 1.5rem;
    border: 1px solid ${theme.palette.neutral[200]};
  `}
`;

export const Trigger = styled(Accordion.Trigger)`
  ${({ theme }) => css`
    display: flex;
    padding: ${theme.layout.spacing(2, 3)};
    align-items: center;
    gap: ${theme.layout.spacing(1)};
    justify-content: space-between;
    border: none;
    background: none;

    &:not(:disabled) {
      cursor: pointer;
    }

    h3 {
      flex: 1;
      text-align: left;
      font-size: ${theme.typography.sizes.title3};
      color: ${theme.palette.text.main};
    }

    > div {
      display: flex;
      align-items: center;
      gap: 0.75rem;

      .indicator {
        display: flex;
        align-items: center;
        justify-content: center;

        font-size: ${theme.typography.sizes.caption};
        color: ${theme.palette.text.light};

        > svg {
          font-size: 1rem;
          color: ${theme.palette.primary.main};
        }
      }
    }

    .open {
      display: none;
    }
    .closed {
      display: block;
    }

    &[data-state='open'] {
      .open {
        display: block;
      }
      .closed {
        display: none;
      }
    }
  `}
`;

export const Content = styled(Accordion.Content)`
  overflow: hidden;

  &[data-state='open'] {
    animation: ${CSSANIMATIONS.ACCORDION_SLIDE_DOWN} 0.3s
      cubic-bezier(0.87, 0, 0.13, 1);
  }
  &[data-state='closed'] {
    animation: ${CSSANIMATIONS.ACCORDION_SLIDE_UP} 0.3s
      cubic-bezier(0.87, 0, 0.13, 1);
  }
`;
